<div
  class="flex flex-col gap-6 p-4 bg-gray-50 rounded-2xl shadow-inner min-h-full"
>
  <form class="flex flex-col gap-2" [formGroup]="formGroup">
    <div
      cdkDropList
      formArrayName="themes"
      class="theme-list flex flex-col gap-4"
      (cdkDropListDropped)="onThemeDrop($event)"
    >
      @for (themeGroup of themes.controls; track themeGroup; let i = $index) {
        <div
          class="theme-card bg-white rounded-xl shadow p-4 transition-all duration-200 hover:shadow-lg"
          data-test-id="re-orderable-theme-card"
          cdkDrag
          [class.error]="shouldHighlightThemeCard(themeGroup)"
          [formGroupName]="i"
        >
          <div
            class="theme-header flex flex-row items-center justify-between gap-2 border-b pb-2"
          >
            <div class="flex flex-row items-center gap-2 flex-grow">
              <mat-icon
                class="drag text-gray-500 cursor-move"
                cdkDragHandle
                matTooltip="Drag to reorder section"
              >
                drag_indicator
              </mat-icon>
              <mat-icon
                class="toggle-collapse cursor-pointer text-gray-600 hover:text-gray-800 transition"
                matTooltip="Expand or collapse"
                (click)="toggleCollapse(i)"
              >
                {{ collapsedStates[i] ? 'expand_more' : 'expand_less' }}
              </mat-icon>
              <input
                formControlName="theme"
                placeholder="Interview section name..."
                matInput
                class="font-bold text-md"
                data-test-id="re-orderable-theme-name-input"
                [class.error]="shouldHighlightThemeName(themeGroup)"
              />
            </div>
            <mat-icon
              class="theme-menu-trigger cursor-pointer"
              data-test-id="re-orderable-theme-interview-section-options-dropdown"
              [matMenuTriggerFor]="themeMenu"
              (click)="$event.stopPropagation()"
            >
              more_horiz
            </mat-icon>
            <mat-menu #themeMenu="matMenu">
              <button class="menu-item" mat-menu-item (click)="cloneTheme(i)">
                <mat-icon>content_copy</mat-icon>
                <span>Clone interview section</span>
              </button>
              <button
                class="menu-item"
                data-test-id="re-orderable-theme-remove-theme-button"
                mat-menu-item
                (click)="removeTheme(i)"
              >
                <mat-icon>close</mat-icon>
                <span>Remove</span>
              </button>
            </mat-menu>
          </div>
          @if (!collapsedStates[i]) {
            <div class="theme-body flex flex-col gap-3 pt-3">
              <div
                cdkDropList
                formArrayName="questions"
                class="question-list flex flex-col gap-2"
                [cdkDropListData]="themeGroup.controls.questions.controls"
                (cdkDropListDropped)="onQuestionDrop(i, $event)"
              >
                @for (
                  questionGroup of themeGroup.controls.questions.controls;
                  track questionGroup;
                  let j = $index
                ) {
                  <div
                    class="question-item bg-gray-100 rounded-lg flex flex-row justify-between items-center gap-2 hover:bg-gray-200 transition"
                    cdkDrag
                    [formGroupName]="j"
                  >
                    <app-question-node
                      [parentForm]="formGroup"
                      [question]="questionGroup"
                      [themeIndex]="i"
                      [depth]="0"
                      [index]="j"
                      [offset]="getThemeOffset(i)"
                      [addQuestion]="addQuestion.bind(this)"
                      [removeQuestion]="removeQuestion.bind(this)"
                      [showErrors]="showErrors"
                    ></app-question-node>
                  </div>
                }
                <button
                  mat-stroked-button
                  color="primary"
                  class="self-start mt-2"
                  data-test-id="re-orderable-theme-add-question-button"
                  (click)="addQuestion(i)"
                >
                  <mat-icon>add</mat-icon>
                  Add question
                </button>
              </div>
              @if (
                getSuggestedQuestions(themeGroup.controls.theme.value).length
              ) {
                <div class="suggested-inline-section">
                  <div class="suggested-inline-header">
                    <span class="suggested-badge">Suggested</span>
                  </div>
                  @for (
                    question of getSuggestedQuestions(
                      themeGroup.controls.theme.value
                    );
                    track question
                  ) {
                    <div class="suggested-inline-item">
                      <span class="suggested-inline-text">{{
                        question.question
                      }}</span>
                      <div class="suggested-inline-actions">
                        <button
                          type="button"
                          mat-icon-button
                          matTooltip="Approve"
                          (click)="approveSuggestion.emit(question.question_id)"
                        >
                          <mat-icon>check</mat-icon>
                        </button>
                        <button
                          type="button"
                          mat-icon-button
                          matTooltip="Decline"
                          (click)="declineSuggestion.emit(question.question_id)"
                        >
                          <mat-icon>close</mat-icon>
                        </button>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </div>

    <button
      mat-raised-button
      color="accent"
      class="self-start mt-4"
      data-test-id="re-orderable-theme-add-theme-button"
      (click)="addTheme()"
    >
      <mat-icon>add</mat-icon>
      Add interview section
    </button>
  </form>
</div>
